import React, { Component } from "react";

export default class ReviewerCell extends Component {
  onCheckChange = (e) => {
    this.props.toggleSelection(this.props.user);
  };

  deleteCallback = () => {
    this.props.removeFromSelected(this.props.user);
  };

  render() {
    var { firstname, lastname, email } = this.props.user;
    var { checked, selectedreviewers, distribution } = this.props;
    var style = { fontSize: 10, overflowWrap: "break-word", color: "#4da1ff" };

    return selectedreviewers === false ? (
      <tr>
        <td
          style={{
            width: "10%",
            textAlign: "center",
            borderBottom: "1px solid #fff",
          }}
        >
          {distribution == "" || distribution == "manual" ? (
            ""
          ) : (
            <label className="checkcontainer">
              <input
                type="checkbox"
                onChange={this.onCheckChange}
                checked={checked}
              />
              <span className="checkcheckmark" />
            </label>
          )}
        </td>

        <td style={{ borderBottom: "1px solid #fff" }}>
          <div className="list-reviewer-name">{firstname + "" + lastname}</div>
          <span style={style}>{email}</span>
        </td>
        {/* <td>{email}</td> */}
      </tr>
    ) : (
      <tr style={{ marginTop: "10px" }}>
        <td
          style={{
            borderBottom: "1px solid #fff",
            borderTop: "1px solid #fff",
            width: "13%",
          }}
        >
          <div className="">
            <button
              className="btn  btn-sm btn-delete modal-table-cross"
              onClick={this.deleteCallback}
              style={{border:'1px solid #f9f9f9'}}
            >
              X
            </button>
          </div>
        </td>
        <td
          style={{
            borderBottom: "1px solid #fff",
            borderTop: "1px solid #fff",
          }}
        >
          <div className="list-reviewer-name ">{firstname + "" + lastname}</div>
          <span style={style}>{email}</span>
        </td>
      </tr>
    );
  }
}
